import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { StyleObj } from '../../@types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useNavigate } from 'react-router';
import useSearchAvailability from '../../hooks/useSearchAvailability';

const styles: StyleObj = {
  searchIcon: {
    color: 'info.300',
    '&:hover': {
      color: 'neutral.25',
    },
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
};

const Search = () => {
  const showSearchIcon = useFeatureIsOn('search-events-feature');
  const { isSearchAvailable } = useSearchAvailability();
  const navigate = useNavigate();

  const handleSearch = () => {
    navigate('/search');
  };

  if (!showSearchIcon || !isSearchAvailable) return null;

  return (
    <IconButton onClick={handleSearch} sx={{ marginRight: '20px' }}>
      <SearchIcon sx={styles.searchIcon} />
    </IconButton>
  );
};

export default Search;
